import React, { Component } from 'react';
import { Col, Row, Card, Modal } from 'antd';
import ProductItem from "components/eCommerce/ProductItem";
import ResponsiveEmbed from "components/ResponsiveEmbed";
import { auth, database } from "../../../firebase/firebase";

class BookGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      urlId: 0,
      series: {},
      books: [],
      isModalVisible: false,
      currentIframe: '',
      modalTitle: ''
    };
    //this.handleChange=this.handleChange.bind(this);
  }

  handleProductClick = (event, product, id) => {
    console.log('Click called', product);
    this.recordContentView(product, id);
    if (product.iframe) {
      console.log('Has iframe', product.iframe);
      this.setState({
        currentIframe: product.iframe,
        modalTitle: product.title || 'Contenido',
        isModalVisible: true
      });
    }else{
      if(product.book_file || product.book_link){
        window.open(product.book_file || product.book_link, '_blank');
      }
    }


  }

  recordContentView = (product, contentId) => {
    const user = auth.currentUser;
    const finalContentId = contentId || product.id || product.title;
    console.log('Record content view called', product, contentId);
    
    if (user && this.state.user.email) {
      database
        .collection("users")
        .where("email", "==", user.email)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // Verificar si ya existe un registro para este contenido
            doc.ref.collection("watched_contents")
              .where("series_id", "==", this.state.urlId)
              .where("content_id", "==", finalContentId)
              .get()
              .then((existingSnapshot) => {
                if (existingSnapshot.empty) {
                  // Solo agregar si no existe ya un registro
                  doc.ref.collection("watched_contents").add({
                    timestamp: new Date(),
                    series_id: this.state.urlId,
                    content_id: finalContentId,
                    content_title: product.title
                  }).then(() => {
                    console.log('Contenido visto registrado');
                    // Actualizar el estado local para marcar como visto
                    this.updateLocalWatchedStatus(finalContentId);
                  }).catch((error) => {
                    console.error('Error registrando contenido visto:', error);
                  });
                } else {
                  console.log('Contenido ya registrado como visto');
                  // Asegurar que esté marcado como visto en la UI
                  this.updateLocalWatchedStatus(finalContentId);
                }
              })
              .catch((error) => {
                console.error('Error verificando contenido visto:', error);
              });
          });
        })
        .catch((error) => {
          console.error('Error encontrando usuario:', error);
        });
    }
  }

  updateLocalWatchedStatus = (contentId) => {
    const updatedBooks = this.state.books.map(book => {
      const bookId = book.id || book.data.id || book.data.title;
      if (bookId === contentId) {
        return {
          ...book,
          _completed: true
        };
      }
      return book;
    });
    this.setState({ books: updatedBooks });
  }

  checkWatchedContents = () => {
    const user = auth.currentUser;
    if (user && this.state.user.email && this.state.books.length > 0) {
      database
        .collection("users")
        .where("email", "==", user.email)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // Obtener todos los contenidos vistos de esta serie
            doc.ref.collection("watched_contents")
              .where("series_id", "==", this.state.urlId)
              .get()
              .then((watchedSnapshot) => {
                const watchedContentIds = [];
                watchedSnapshot.forEach((watchedDoc) => {
                  watchedContentIds.push(watchedDoc.data().content_id);
                });
                
                // Marcar libros como completados si están en la lista de vistos
                const updatedBooks = this.state.books.map(book => {
                  const bookId = book.id || book.data.id || book.data.title;
                  
                  if (watchedContentIds.includes(bookId)) {
                    return {
                      ...book,
                      _completed: true
                    };
                  }
                  return book;
                });
                
                this.setState({ books: updatedBooks });
              })
              .catch((error) => {
                console.error('Error obteniendo contenidos vistos:', error);
              });
          });
        })
        .catch((error) => {
          console.error('Error encontrando usuario:', error);
        });
    }
  }

  handleCloseModal = () => {
    this.setState({
      isModalVisible: false,
      currentIframe: '',
      modalTitle: ''
    });
  }

  getUserInformation(user) {
    //console.log("ALL USER INFO CALLED");
    var _this = this;
    database
      .collection("users")
      .where("email", "==", user.email)
      .get()
      .then(function(querySnapshot) {
        //console.log("ID: " + _this.state.urlId);
        querySnapshot.forEach(function(doc) {
          _this.setState({ user: doc.data() });
          doc.ref
            .collection("accesed_series")
            .where("series_id", "==", _this.state.urlId)
            .get()
            .then(function(snapshot) {
              var refArray = [];
              snapshot.forEach(function(series) {
                refArray.push(series.data());
              });
              //console.log(refArray);
              if (refArray.length == 0) {
                //console.log("NO ACCESS TO THIS BOOK");
              } else {
                database
                  .doc("series/" + _this.state.urlId)
                  .get()
                  .then(function(doc) {
                    if (doc.exists) {
                      var series = doc.data();
                      //console.log(series);
                      _this.setState({ series: series });
                        database
                          .collection("books")
                          .where("series","==",doc.id)
                          .get()
                          .then(function(snapshot) {
                            //console.log("BOOKS")
                            var arr = snapshot.docs.map(function(doc) {
                              return {
                                id: doc.id,
                                data: doc.data(),
                                _completed: false
                              };
                            }).sort(function(a, b) {
                              var aOrder = parseFloat(a.data.order);
                              var bOrder = parseFloat(b.data.order);
                              var normalizedAOrder = isNaN(aOrder) ? Number.MAX_SAFE_INTEGER : aOrder;
                              var normalizedBOrder = isNaN(bOrder) ? Number.MAX_SAFE_INTEGER : bOrder;

                              if (normalizedAOrder !== normalizedBOrder) {
                                return normalizedAOrder - normalizedBOrder;
                              }

                              return String(a.data.title || '').localeCompare(String(b.data.title || ''));
                            });
                            //console.log(snapshot.docs[0].data())
                            _this.setState({ books: arr });
                            
                            // Verificar contenidos vistos
                            _this.checkWatchedContents();
                          });
                    } else {
                      //console.log("Series does not exist");
                    }
                  });
              }
            });
        });
      })
      .catch(function(error) {
        //console.log("Error gettin0g document:", error);
      });
  }

  componentDidMount() {
    const { urlId } = this.props.match.params;
    var _this = this;

    this.setState({ urlId: urlId });
    auth.onAuthStateChanged(user => {
      if (user) {
        _this.getUserInformation(user);
      }
    });
  }

  render() {
    return ( 
      <div>
				<Row>
					<Col key="ss" xl={16} lg={16} md={16} sm={24} xs={24}>
						<Card className={`gx-card-metrics`}>
							<h1 className="gx-product-title">{this.state.series.sponsor}</h1>
							<h4>{this.state.series.books_description}</h4>
							<p>{this.state.series.sponsor_message}</p>
							<p>{this.state.series.disclamer}</p>
						</Card>
					</Col>
					<Col key="1a" xl={8} lg={8} md={8} sm={24} xs={24}>
						<Card className={`gx-card-metrics`}>
							<img src={this.state.series.sponsor_logo} />
						</Card>
					</Col>
     
     
        {this.state.books.map((book, index) => {
          const bookData = book.data;
          const isCompleted = book._completed || false;
          const bookId = book.id || bookData.id || bookData.title;
          
          return (
            <Col key={index} xl={6} md={8} sm={24} xs={24}>
              <ProductItem 
                key={index} 
                grid 
                product={bookData} 
                click={this.handleProductClick} 
                completed={isCompleted}
                showinfo={true}
                porcentage={isCompleted ? 100 : 0}
                id={bookId}
              />
            </Col>
          );
        })}
      </Row>
      <Modal
        className="embed-modal"
        title={this.state.modalTitle}
        visible={this.state.isModalVisible}
        onCancel={this.handleCloseModal}
        footer={null}
        centered
        width={980}
        style={{ paddingBottom: 0 }}
        bodyStyle={{ padding: 0, overflow: 'hidden' }}
        maskClosable={false}
        keyboard={false}
        destroyOnClose
      >
        {this.state.currentIframe && (
          <ResponsiveEmbed
            src={this.state.currentIframe}
            title={this.state.modalTitle}
          />
        )}
      </Modal>
      </div>
    );
  }
}

export default BookGrid;
